import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const LockerClosedIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_lockerclosedillustration_svg_a)"
      d="m78.465 149.676 22.381-4.001-29.37-14.554-22.352 4.014z"
    />
    <path fill="#C8C8C8" d="M139.577 16.936 71.664 29.128l29.369 14.554 67.914-12.192z" />
    <path fill="#555" d="M100.846 43.495v102.179l-29.37-14.553V28.941z" />
    <path fill="#FBCE08" d="M101.237 44.065v100.951l67.13-12.051V32.013z" />
    <path fill="#C39000" d="m100.91 95.182-.04.39 66.555-11.948v-.383z" />
    <path fill="#FCDE84" d="M101.237 95.48v.797l66.855-12.015v-.795z" />
    <path fill="#393939" d="M135.66 88.904v49.018l31.3-5.619V83.239z" />
    <path fill="#706D6D" d="m135.66 116.793 31.3 15.512-31.3 5.617z" />
    <path fill="#FCDE84" d="m135.662 111.525 3.621 1.799 22.796-4.084-12.976-6.449-13.465 2.413" />
    <path fill="url(#dhl__illustrations_lockerclosedillustration_svg_b)" d="m135.477 134.561 3.803-.752-3.687-1.828" />
    <path fill="#DBB569" d="m135.66 110.183 20.826-3.731-2.159-1.071-18.667 3.325z" />
    <path fill="#C39000" d="m135.635 111.502 3.645 1.813v20.488l-3.636-1.807" />
    <path fill="#FBCE08" d="M139.28 113.314v20.49l22.796-4.085V109.23z" />
    <path fill="#fff" d="M145.957 121.782v7.709l13.309-2.39v-7.707z" />
    <path
      fill="#000"
      d="m153.632 126.612 2.333-.41v-4.597l-2.333.41zM49.124 149.676h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#000"
      d="m147.214 127.736 1.974-.346v-4.597l-1.974.346zm-98.09 21.94h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#000"
      d="M151.373 127.008c.327-.056.632-.11.971-.17v-4.593l-.971.171zm-102.25 22.668H168.76V16.749H49.124zm0-132.927H168.76v132.927H49.124z"
    />
    <path
      fill="#000"
      d="m158.009 121.245-.991.174v4.598l.991-.174zM49.124 149.676h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#000"
      d="m150.257 127.207.397-.07v-4.596l-.397.07zM49.124 149.676h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#FCDE84"
      d="m135.662 97.271 4.331 2.152 14.337-2.569-8.161-4.055-10.507 1.883zm-86.538 52.405h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path fill="#DBB569" d="m136.477 97.676 14.337-2.57-1.358-.671-13.794 2.456v.38z" />
    <path
      fill="#C39000"
      d="m135.605 97.242 4.387 2.181v12.885l-4.357-2.156zm-86.481 52.434h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#FBCE08"
      d="M139.993 99.423v12.886l14.337-2.569V96.854zm-90.87 50.253H168.76V16.749H49.124zm0-132.927H168.76v132.927H49.124z"
    />
    <path
      fill="#fff"
      d="M144.193 104.749v4.848l8.368-1.504v-4.847zm-95.07 44.927H168.76V16.749H49.124zm0-132.927H168.76v132.927H49.124z"
    />
    <path
      fill="#000"
      d="m149.019 107.787 1.467-.258v-2.892l-1.467.259zm-99.895 41.889h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#000"
      d="m144.982 108.493 1.241-.217v-2.891c-.422.073-.825.144-1.241.218zm-95.858 41.183h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#000"
      d="m147.597 108.036.612-.108v-2.888l-.612.108zm-98.473 41.64h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#000"
      d="m151.771 104.412-.623.109v2.892l.623-.11zM49.124 149.676h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#000"
      d="m146.896 108.161.25-.044v-2.891l-.25.044zm-97.772 41.515h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#C39000"
      d="m100.91 119.485-.041.391 34.6-6.237.04-.39zm-51.786 30.191h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M101.096 119.818v.795l33.956-6.096v-.796zm-51.972 29.858h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#C39000"
      d="M135.045 50.09v.351l33.322-6.01v-.35zm-85.921 99.586h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M135.021 50.442v.795l32.679-5.87v-.795zm-85.897 99.234h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#C39000"
      d="m100.91 82.85-.04.39 66.555-11.948v-.383zm-51.786 66.826h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M101.042 83.195v.796l67.134-12.047v-.795zm-51.918 66.481h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#C39000"
      d="m100.91 70.593-.04.39 66.555-11.948v-.383zm-51.786 79.083h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M101.194 70.909v.794l66.982-12.025v-.795zm-52.07 78.767h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#C39000"
      d="M100.87 64.787v.35l66.555-11.948v-.35zm-51.746 84.889h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M101.237 65.058v.796l67.522-12.12v-.795zm-52.113 84.618h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#8E8E8E"
      d="M100.846 144.175v.375l67.913-12.191v-.376zm-51.722 5.501h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M134.901 37.57v101.943l.764-.139V37.367zM49.124 149.677h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#555"
      d="m168.759 31.917-.458.082v-.601l-1.333.263v.577L100.846 44.11v3l66.122-11.87v98.15l1.333-.256V34.998l.458-.081zM49.124 149.676h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m105.818 56.371 3.441-.652-.187.283-3.254.616zm-56.694 93.305h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m105.818 55.913 3.791-.72-.188.283-3.603.684zm-56.694 93.763h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m105.818 56.83 3.093-.586-.187.28-2.904.551zm-56.694 92.846h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m131.263 51.792-3.428.65.188-.283 3.238-.614zm-82.14 97.884H168.76V16.749H49.124zm0-132.927H168.76v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m131.263 52.25-3.776.716.187-.281 3.588-.681zm-82.14 97.426H168.76V16.749H49.124zm0-132.927H168.76v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m128.371 51.634 2.89-.549v.248l-3.077.584zm-79.247 98.042h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m109.152 56.444 1.63-2.455 2.027-.384c.224-.043.221.04.111.205l-.413.621c-.057.087-.161.243.184.178l2.714-.516c-.225.342-.956 1.346-2.271 1.595zm-60.028 93.232h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m118.501 53.505-.883 1.333-2.336.443.884-1.331zm-69.377 96.171h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m121.88 52.865-.886 1.331-2.333.444.884-1.333zm-72.756 96.811h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m122.639 52.722-.253.383c-.293.438-.033.835.924.654l3.749-.711.885-1.333zm-73.515 96.954h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m110.288 52.748-.81 1.223 4.43-.84c.224-.043.221.04.112.203-.111.167-.296.456-.409.625-.058.086-.161.242.183.176l1.812-.343s.291-.44.536-.807c.332-.5.027-1.352-1.165-1.126zm-61.164 96.928h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m122.079 52.564-5.712 1.084 1.559-2.348 2.335-.443-.894 1.346 1.042-.198.894-1.345 2.335-.444zm-72.955 97.112h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m126.871 49.603-1.558 2.348-2.475.469 1.56-2.348zM49.124 149.676h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#8E8E8E"
      d="m167.425 132.221-65.245 11.715v-97.68l65.245-11.714zm-66.579-88.727v102.181l67.913-12.193V31.303zM49.124 149.676h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#C39000"
      d="M135.302 40.923v97.066l.363-.065V40.851zM49.124 149.676h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path
      fill="#555"
      d="M126.147 39.712v1.5l17.311-3.125v-1.5zM49.124 149.676h119.635V16.749H49.124zm0-132.927h119.635v132.927H49.124z"
    />
    <path fill="#FBCE08" d="m135.635 88.906-.002 1.078v47.94l31.327-5.62V83.241z" />
    <path fill="#C39000" d="M135.638 88.906v.373l31.326-5.647v-.391z" />
    <path fill="#FCDE84" d="M135.635 89.28v.794l31.326-5.648v-.793z" />
    <defs>
      <linearGradient
        id="dhl__illustrations_lockerclosedillustration_svg_a"
        x1={57.566}
        x2={70.116}
        y1={143.02}
        y2={119.982}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.5} stopColor="gray" stopOpacity={0.5} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_lockerclosedillustration_svg_b"
        x1={118.742}
        x2={138.971}
        y1={137.578}
        y2={119.879}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.5} stopColor="gray" stopOpacity={0.5} />
        <stop offset={1} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
